<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- main text -->
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('invoiceMonitor.about.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('invoiceMonitor.about.text.01')}}
          </v-col>
        </v-row>
        <!-- pros checked -->
        <v-row class="py-8 max-width-1000 mx-auto">
          <v-col
            v-for="(item,index) in pros"
            :key="index"
            cols="12" sm="6"
            class="px-12">
            <v-row align="center">
              <v-col cols="2"
                style="min-width: 66px;">
                <v-icon
                  size="42"
                  color="success">
                  mdi-checkbox-marked-outline
                </v-icon>
              </v-col>
              <v-col>
                {{ $t(item.text)}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- recommend -->
        <!-- <v-row class="pt-8">
          <v-col class="display-1">
            {{ $t('common.ForWho')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('invoiceMonitor.about.text.02')}}
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'About',
    extends: DataComponentBase,

    data: () => ({
      pros: [
        { text: "invoiceMonitor.about.pros.01" },
        { text: "invoiceMonitor.about.pros.02" },
        { text: "invoiceMonitor.about.pros.03" },
        { text: "invoiceMonitor.about.pros.04" },
      ],
    }),

    methods: {

    },
  }
</script>
